import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import SuccessIcon from '@material-ui/icons/Check';
import ErrorIcon from '@material-ui/icons/Error';
import { RiFileTextLine } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { Link } from '../Link/Link';
import { ProgressBar } from '@Components/ProgressBar/ProgressBar';
import styles from './FileRow.module.scss';

interface FileRowProps {
  id: string | number;
  filename: string;
  isUploading: boolean;
  onDelete: (id: string | number) => void;
  url?: string;
  progress?: number;
  isFailed?: boolean;
  error?: string;
  onRetry?: (id: string) => void;
}

export const FileRow = ({
  id,
  filename,
  isUploading,
  onDelete,
  url,
  progress,
  isFailed = false,
  onRetry,
}: FileRowProps) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.fileRow}>
      <div className={styles.fileList}>
        <RiFileTextLine size={20} />
        {isUploading ? (
          <span>{filename}</span>
        ) : (
          <Link underline href={url}>
            {filename}
          </Link>
        )}
      </div>

      {isUploading && progress !== undefined && (
        <div className={styles.progressBar}>
          <ProgressBar value={progress} />
        </div>
      )}

      {isFailed && (
        <div className={styles.failedUpload}>
          <div className={styles.failedMessage}>
            <span className={styles.failedIcon}>
              <ErrorIcon style={{ fontSize: 18 }} />
            </span>
            <span className={styles.failedText}>{t('file_upload.upload_failed')}</span>
          </div>
        </div>
      )}

      <div className={styles.meta}>
        {!isUploading && !isFailed && (
          <span className={styles.completeIcon}>
            <SuccessIcon style={{ fontSize: 18 }} />
          </span>
        )}
        {isFailed && onRetry && (
          <button onClick={() => onRetry(String(id))} className={styles.retryButton} type="button">
            {t('file_upload.retry')}
          </button>
        )}
        <button
          onClick={() => onDelete(id)}
          className={styles.deleteIcon}
          type="button"
          aria-label={isUploading ? 'Cancel upload' : 'Remove file'}
        >
          <DeleteIcon style={{ fontSize: 18 }} />
        </button>
      </div>
    </div>
  );
};
